import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mx-auto block w-full max-w-[720px] bg-white',
    text: 'heading-s'
  },
  variants: {
    highlight: {
      true: {
        text: 'heading-s-bold'
      }
    }
  }
});
